export default {
  namespaced: true,
  state: () => ({
    list: [],
    archive: [],
  }),
  mutations: {
    addNotification(state, notification) {
      state.list.push(notification);
    },
    removeNotification(state) {
      const notification = state.list.slice(0, 1);
      if (state.archive.length > 500) {
        state.archive = state.archive.slice(450);
      }
      state.archive.push(notification);
      state.list.splice(0, 1);
    },
  },
  actions: {
    new(
      { commit },
      {
        title = 'Notification Headline',
        message = '',
        icon = null,
        type = undefined,
      }
    ) {
      console.log('--> [ Notification ] ', title, message);
      if (process.env.NOTIFICATIONS) {
        commit('addNotification', {
          title,
          message,
          icon,
          type,
          id: Math.floor(Math.random() * Date.now()),
        });
        setTimeout(() => {
          console.log('notification remove');
          commit('removeNotification');
        }, 6000);
      }
    },
    socket({ dispatch }, { title, message }) {
      dispatch('new', { title, message, type: 'socket' });
    },
    error({ dispatch }, { title, message }) {
      const errorObject = {
        title: 'Error: ' + title,
        message,
        type: 'error',
      };
      dispatch('new', errorObject);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/notification.js